export const Denied = "denied";